import React from "react";
import { MapRef } from "react-map-gl/maplibre";
import {
  PatientTaskBroadcastDetails,
  PatientTaskInstance,
  PatientTaskInstanceId,
} from "../../../messages";
import { AppCaregiver } from "../../../system/AppState/AppCaregiverState";
import { Visit } from "../../../system/AppState/AppVisitsState";
import { List } from "../../../utils/List";
import { RaffleBannerData } from "../../Raffle/Raffle.types";
import useMainLayoutPreference from "../hooks/useMainLayoutPreference";
import { MainScreenActiveCard } from "../main-utils";
import { MainLayoutCardsView } from "./MainLayoutCardsView";
import { MainLayoutMapView } from "./MainLayoutMapView";
import { DefinedPlaceResult } from "./MainNavbar";

type Props = {
  caregiver: AppCaregiver;
  visits: List<Visit>;
  visitsOutsideAvailability: List<Visit>;
  tasks: List<PatientTaskBroadcastDetails>;
  assignedTasks: List<PatientTaskInstance>;
  activeCard: MainScreenActiveCard | null;
  mapRef: MapRef | null;
  searchedPlace: DefinedPlaceResult | null;
  setMapRef: React.Dispatch<React.SetStateAction<MapRef | null>>;
  raffle: RaffleBannerData | null;
  showVisitsOutsideAvailability: boolean;
  onToggleShowVisitsOutsideAvailability: () => void;
  onClickRaffleBanner: () => void;
  onClickMap: () => void;
  onClickVisit: (visit: Visit) => void;
  onClickTask: (taskInstanceId: PatientTaskInstanceId) => void;
  onClickCaregiverMarker: (e: React.MouseEvent<Element>) => void;
  onClickVisitMarker: (visit: Visit, e: React.MouseEvent<Element>) => void;
  onClickTaskMarker: (task: PatientTaskBroadcastDetails, e: React.MouseEvent<Element>) => void;
  onClickAssignedTaskMarker: (task: PatientTaskInstance, e: React.MouseEvent<Element>) => void;
  onClickPreferenceSettings: () => void;
};

export function MainLayoutView(props: Props) {
  const [mainLayout] = useMainLayoutPreference();

  switch (mainLayout) {
    case "Map":
      return (
        <MainLayoutMapView
          key="map-view"
          caregiver={props.caregiver}
          visits={props.visits}
          visitsOutsideAvailability={props.visitsOutsideAvailability}
          tasks={props.tasks}
          assignedTasks={props.assignedTasks}
          activeCard={props.activeCard}
          searchedPlace={props.searchedPlace}
          mapRef={props.mapRef}
          setMapRef={props.setMapRef}
          showVisitsOutsideAvailability={props.showVisitsOutsideAvailability}
          onToggleShowVisitsOutsideAvailability={props.onToggleShowVisitsOutsideAvailability}
          onClickMap={props.onClickMap}
          onClickCaregiverMarker={props.onClickCaregiverMarker}
          onClickVisitMarker={props.onClickVisitMarker}
          onClickTaskMarker={props.onClickTaskMarker}
          onClickAssignedTaskMarker={props.onClickAssignedTaskMarker}
        />
      );

    case "Cards":
      return (
        <MainLayoutCardsView
          key="cards-view"
          caregiver={props.caregiver}
          visits={props.visits}
          visitsOutsideAvailability={props.visitsOutsideAvailability}
          tasks={props.tasks}
          onClickVisit={props.onClickVisit}
          onClickTask={props.onClickTask}
          raffle={props.raffle}
          onClickRaffleBanner={props.onClickRaffleBanner}
          onClickPreferenceSettings={props.onClickPreferenceSettings}
        />
      );
  }
}
